// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-30T02:11:06.491Z
// Property: 206 Bell Apartments (ID: 6767906449167306)
// Collections: 41 amenities, 16 floorplans (live), 17 photos, 44 POIs, 2 reviews, 4 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167306",
  "property_external_id": "1654449",
  "property_zillow_url": "https://www.zillow.com/apartments/seattle-wa/206-bell-apartments/5XpCYC/",
  "property_apartments_url": "https://www.apartments.com/206-bell-seattle-wa/3v1hy4e/",
  "property_google_business_url": "https://www.google.com/maps/place/206+Bell+Apartments/data=!4m2!3m1!1s0x0:0x168bdbb2ef0f5d4e?sa=X&ved=2ahUKEwiP2au3782TAxVDDkQIHRZJCK8Q_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "52910892360",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "206-bell-apartments",
  "property_name": "206 Bell Apartments",
  "property_website_url": "https://www.206bell.com/",
  "property_domain": "https://www.206bell.com/",
  "property_address": "206 Bell St",
  "property_full_address": "206 Bell St, Seattle, WA 98121",
  "property_address_1": "206 Bell St",
  "property_address_2": null,
  "property_address_city": "Seattle",
  "property_address_state": "WA",
  "property_address_zip_full": null,
  "property_address_zip": "98121",
  "property_address_country": "US",
  "property_address_county": "King County",
  "property_neighborhood_address": "Downtown Seattle",
  "property_address_latitude": "47.6144338",
  "property_address_longitude": "-122.3456481",
  "property_email": "206bell@weidner.com",
  "property_phone": "(564) 262-7782",
  "property_call_tracking_phone": "564-262-7782",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.206bellseattle.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Downtown Seattle energy, Belltown ease.</strong> Find studio, one-, and two-bedroom apartments with modern finishes, rooftop spaces, skyline views, and everyday city connections—then see available floor plans and make 206 Bell your Seattle base.</p>",
  "property_long_description": "<p><strong>Downtown Seattle energy, Belltown ease.</strong> At 206 Bell Apartments, you’re set between the city’s best-known icons and everyday essentials—near Pike Place Market, Seattle Center, MoPOP, Westlake Center, Bell Street Park, and the waterfront paths by Olympic Sculpture Park. Dining, coffee, live music, shopping, transit, and quick connections to I-5, 99, 520, and I-90 keep the whole city within reach.</p><p>Choose from efficient studios, polished one-bedrooms, and roomy two-bedroom layouts, then settle into modern finishes like stainless steel appliances, quartz countertops, hard-surface flooring, in-home washer and dryer, key fob entry, and select balconies, walk-in closets, and city, mountain, or water views. Beyond your door, <a href=\"/amenities\">rooftop amenities</a> bring the skyline home with a terrace, firepit, grilling area, covered Sky Lounge, billiards room, resident lounge, 24-hour fitness center, package receiving, bike storage, EV parking, reserved garage parking, and pet-friendly spaces. See the <a href=\"/floor-plans\">available floor plans</a> and make Belltown your Seattle base.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022f-9193-75e8-8565-2b2005b03f46.webp",
  "property_featured_image_media": {
    "alt_text": "Rooftop lounge area with city skyline and water view at sunset.",
    "public_id": "019d022f-9193-75e8-8565-2b2005b03f46",
    "storage_key": "property/6767906449167306/019d022f-9193-75e8-8565-2b2005b03f46.webp",
    "width": 2560,
    "height": 1707
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "123",
  "property_year_built": "2013",
  "property_year_renovated": null,
  "property_walk_score": "99",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.3089430894309",
  "property_admin_fee": null,
  "property_application_fee": "25",
  "property_fees_deposit_info": "Deposit: $600",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Maximum 2 pets per unit.",
  "property_pet_policy_description": "Cats and dogs welcome. Pet rent: $50/month. Pet deposit: $300 per pet. Maximum 2 pets per unit.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://206bell.securecafe.com/onlineleasing/206-bell-0/floorplans.aspx",
  "property_resident_portal_url": "https://206bell.securecafenet.com/residentservices/206-bell-0/userlogin",
  "property_apply_now_url": "https://206bell.securecafe.com/onlineleasing/206-bell-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022d-cd86-754c-aa5d-15bda282cdbc.webp",
  "property_primary_logo_media": {
    "alt_text": "Logo with a large red circle showing the number 200 and a gray badge reading BELL on the right.",
    "public_id": "019d022d-cd86-754c-aa5d-15bda282cdbc",
    "storage_key": "property/6767906449167306/019d022d-cd86-754c-aa5d-15bda282cdbc.webp",
    "width": 1920,
    "height": 1484
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022f-d40b-74ac-9a93-3f1265d64a80.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Logo with the number 206 inside a circle.",
    "public_id": "019d022f-d40b-74ac-9a93-3f1265d64a80",
    "storage_key": "property/6767906449167306/019d022f-d40b-74ac-9a93-3f1265d64a80.webp",
    "width": 640,
    "height": 495
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022f-dc87-71e5-9dd9-d4d6b49e4f7d.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Logo with the number 206 inside a black circle.",
    "public_id": "019d022f-dc87-71e5-9dd9-d4d6b49e4f7d",
    "storage_key": "property/6767906449167306/019d022f-dc87-71e5-9dd9-d4d6b49e4f7d.webp",
    "width": 640,
    "height": 495
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#5b5b5b",
  "property_secondary_color": "#ed1d24",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#ffffff",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "418 - 1075",
  "property_sqft_min": "418",
  "property_sqft_max": "1075",
  "property_price_range": "1448 - 2844",
  "property_price_min": "1448",
  "property_price_max": "2844",
  "property_available_units": 21,
  "property_facebook_url": "https://www.facebook.com/206Bell/",
  "property_instagram_url": "https://www.instagram.com/206bell/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJZUeMNEwVkFQRTl0P77LbixY",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to 206 Bell Apartments",
  "property_home_romance_title": "Embrace the Joy of Living in Your New Apartment Home",
  "property_home_amenities_blurb": "<p><strong>Skyline views, smart conveniences, more room to unwind.</strong> At 206 Bell, the rooftop terrace, gas firepit, grilling area, and covered Sky Lounge bring Puget Sound scenery upstairs, while the billiards room, resident lounge, and 24-hour fitness center add everyday breathing room. Downstairs, package receiving, valet dry cleaning, bike storage, EV parking, and reserved garage parking keep routines moving with ease.</p>",
  "property_home_floorplans_blurb": "<p><strong>Studio to penthouse-style layouts in Downtown Seattle.</strong> Explore floor plans shaped for polished everyday living, with stainless appliances, quartz countertops, floating hardwood floors, full-size in-home laundry, and smart storage. Select homes add private balconies, walk-in closets, corner layouts, or city, mountain, and water views—so it’s easy to compare the details that matter most.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture 206 Bell from every angle.</strong> Preview bright apartments with wide windows, stainless steel kitchens, rich cabinetry, and open living space, then step into polished amenity scenes from the fitness center to the billiards room. The rooftop seals the view with lounge seating, string lights, grills, a firepit, and sweeping water and skyline backdrops above Belltown.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Belltown keeps Seattle close.</strong> Step out to 2nd Avenue cafés, Rocco’s, SIFF Cinema Downtown, and live music at The Crocodile, with Tilikum Place and the waterfront nearby for a slower moment. RapidRide and downtown bus lines make it easy to reach SLU, Capitol Hill, Queen Anne, and beyond—then return to skyline views from the rooftop at 206 Bell Apartments.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents highlight service that makes life easier.</strong> Reviews call out helpful move-in support, quick follow-through, and a professional team— including shoutouts to Tila and Cori for making moving into 206 Bell “a dream.”</p><p>They also note the tidy, well-kept building, reliable elevators, resident events, and a Downtown Seattle address close to bars, restaurants, and the waterfront. Read the reviews to hear more firsthand.</p>",
  "property_neighborhood_blurb": "<p><strong>Belltown puts the city on your schedule.</strong> From 206 Bell Apartments, you can trade long drives for quick walks to 2nd Avenue cafés, late-night slices at Rocco’s, films at SIFF Cinema Downtown, and live sets at The Crocodile. Tilikum Place and the waterfront add easy pauses between errands, while nearby RapidRide and downtown bus lines connect you to South Lake Union, Capitol Hill, Queen Anne, and beyond. When you want more breathing room, head toward Elliott Bay for art, shoreline paths, and sunset views, then come home to a rooftop made for taking in the skyline. Explore the map, picture your favorite route, and <a href=\"/schedule-a-tour\">schedule a tour</a> to see how this Downtown Seattle location fits your day.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that make more room for your day.</strong> Start upstairs, where the rooftop terrace, gas firepit, grilling area, and covered Sky Lounge turn skyline and Puget Sound views into a daily perk. Inside, a billiards room and resident lounge give you comfortable space beyond your front door, while the 24-hour fitness center keeps workouts close.</p><p>Everyday details are just as considered: package receiving, valet dry cleaning, free bike storage, EV parking, reserved garage parking, Wi-Fi hot spots, and quick transit access help simplify the routine. In your apartment, full-size laundry, floating hardwood floors, stainless appliances, glass-top ranges, undermount sinks, and ample storage create a polished Downtown Seattle base, with select homes adding balconies, walk-in closets, and city, mountain, or water views. Explore the <a href=\"/gallery\">amenity photos</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see them in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Belltown your Seattle base?</strong> Start your application for 206 Bell Apartments online and move toward a home with modern finishes, efficient studio to two-bedroom layouts, and rooftop spaces that bring the skyline close. Explore <a href=\"/floor-plans\">available floor plans</a>, then apply when you’re ready.</p>",
  "property_contactus_blurb": "<p><strong>Questions about 206 Bell Apartments?</strong> Connect with the leasing team for help with availability, floor plans, modern finishes, rooftop amenities, pet-friendly spaces, parking, or directions to our Belltown address. We’re here to make your next step simple.</p>",
  "property_faqs_blurb": "<p><strong>Questions about 206 Bell?</strong> Start here for quick answers about leasing, floor plans, amenities, pet-friendly spaces, parking, and everyday living in Belltown. If you don’t see what you need, the leasing team is happy to help with details, availability, or tour scheduling.</p>",
  "property_floorplans_blurb": "<p><strong>Find the floor plan that gives your day the right shape.</strong> At 206 Bell Apartments, you can compare efficient studios, flexible one-bedroom layouts, roomy two-bedroom homes, and an elevated penthouse-style option—all with the details that make each layout feel polished from the start. Picture stainless appliances and quartz countertops in the kitchen, floating hardwood floors underfoot, full-size laundry in your home, and smart storage that helps keep the main living area open and easy to use.</p><p>Select layouts add private balconies, walk-in closets, corner positioning, or city, mountain, and water views, giving you more ways to choose what matters most. Browse current pricing and availability, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how your favorite Downtown Seattle floor plan feels in person.</p>",
  "property_gallery_blurb": "<p><strong>See the details come into focus.</strong> The 206 Bell Apartments photo gallery moves from bright apartment interiors to elevated rooftop scenes, giving you a visual feel for life above Belltown. Scan kitchens with stainless steel appliances, rich cabinetry, and open living areas framed by wide windows. Then look upstairs, where the roof deck layers lounge seating, string lights, a firepit, grills, and sweeping water and skyline views into one memorable setting.</p><p>Inside the community spaces, photos capture the billiards room, fitness center, and inviting lounge areas with the same polished, city-ready style. Browse the gallery, explore more <a href=\"/virtual-tours\">virtual tours</a>, and <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see 206 Bell in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Belltown from 206 Bell.</strong> Use the interactive map to browse available apartments and see how close downtown icons, daily essentials, waterfront paths, dining, coffee, live music, shopping, transit, and quick highway connections are from your Seattle base.</p>",
  "property_pets_blurb": "<p><strong>Pets get a routine here, not just permission.</strong> At 206 Bell Apartments, cats and dogs can share your Downtown Seattle home base, from sunny window naps to quick leash-up breaks close to home. The community adds thoughtful touches for pet life, including treats in the office and frequent Yappy Hours, while nearby off-leash space at Regrade Park gives dogs a dedicated place to stretch their legs.</p><p>Back at home, full-size laundry, ample storage, and hard-surface flooring help keep daily cleanup simple, and the rooftop terrace gives you a fresh-air pause with skyline and water views. Explore more <a href=\"/amenities\">pet-friendly community features</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how 206 Bell fits your pet’s day-to-day rhythm.</p>",
  "property_referafriend_blurb": "<p><strong>Share your Belltown base.</strong> If you love the downtown energy, rooftop skyline moments, modern finishes, and easy access that make 206 Bell Apartments feel connected to everything, invite a friend to see it for themselves. Send a referral and help them find their place here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, Belltown ease.</strong> Log in to pay rent, submit maintenance requests, and manage your 206 Bell account in one convenient place—so you can get back to enjoying modern finishes, rooftop skyline spaces, and the Downtown Seattle energy just beyond your door.</p>",
  "property_reviews_blurb": "<p><strong>See what residents are saying about 206 Bell Apartments.</strong> Reviews point to a team that makes the details easier—from move-in support to prompt follow-through on requests. One resident shared that Tila and Cori “made moving into 206 Bell a dream,” while another praised the staff as “super responsive” and professional.</p><p>You’ll also see residents call out the tidy, well-kept building, reliable elevators, resident events, and a Downtown Seattle location with bars, restaurants, and the waterfront within easy reach. Read the reviews below for firsthand perspective on daily life at 206 Bell.</p>",
  "property_created_at": "1773426347433",
  "property_scheduletour_blurb": "<p><strong>See Belltown from the rooftop.</strong> Tour 206 Bell Apartments and get a closer look at modern studios, one-, and two-bedroom homes with quartz countertops, stainless steel appliances, in-home laundry, and select skyline views—then head up to the terrace, Sky Lounge, and fitness center. Schedule your visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we received your inquiry.</strong><br>The leasing team will be in touch soon to help with your next steps. At 206 Bell Apartments, modern studio, one-, and two-bedroom homes pair polished finishes with rooftop spaces and easy Belltown access—an energized Seattle base with everyday comfort built in.</p>",
  "property_virtualtours_blurb": "<p><strong>Tour the layout before you step inside.</strong> Move through 206 Bell Apartments online and compare the homes available to preview: two studio options, a one-bedroom, and a two-bedroom. Each walkthrough lets you slow down, turn around, and study the details that matter in real life—from stainless appliances and quartz-style kitchen surfaces to the way the living area, sleeping space, storage, and windows work together.</p><p>Use the virtual tours to narrow your favorite Downtown Seattle apartment, then compare current <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready for a closer look.</p>",
  "property_copyright": "2026 All Rights Reserved. 206 Bell Apartments",
  "property_seo_title_home": "206 Bell Apartments |  Apartments in Seattle, WA",
  "property_seo_description_home": "Elevate your Seattle lifestyle at 206 Bell Apartments! Enjoy breathtaking views, modern amenities, and pet-friendly homes. Secure your new space today!",
  "property_seo_title_floorplans": "Floor Plans | Seattle, WA Apartments for Rent",
  "property_seo_description_floorplans": "Find your sanctuary at 206 Bell Apartments in Seattle, WA. Choose from stylish Studio, One, or Two Bedroom floor plans—your ideal home awaits!",
  "property_seo_title_amenities": "Amenities | Seattle, WA Apartments for Rent",
  "property_seo_description_amenities": "Experience urban living at 206 Bell Apartments in Seattle! Enjoy stunning views, top-notch amenities, and pet-friendly homes designed for your lifestyle.",
  "property_seo_title_gallery": "Gallery | Apartments in Seattle, WA",
  "property_seo_description_gallery": "Experience urban living at 206 Bell Apartments in Seattle! Enjoy stunning views, modern amenities, and spacious floor plans. Picture your new life today!",
  "property_seo_title_virtualtours": "Virtual Tours | 206 Bell Apartments Apartments",
  "property_seo_description_virtualtours": "Experience Seattle living at 206 Bell Apartments! Take a virtual tour of stunning one and two-bedroom floor plans. Your ideal home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | 206 Bell Apartments Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at 206 Bell Apartments in Seattle! Explore floor plans and pricing with our interactive map, featuring stunning city views.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Seattle, WA",
  "property_seo_description_neighborhood": "Uncover Seattle living at 206 Bell Apartments! Dive into vibrant neighborhoods with local favorites and nearby attractions just a stone's throw away.",
  "property_seo_title_contact": "Contact Us | 206 Bell Apartments",
  "property_seo_description_contact": "Connect with our friendly leasing team at 206 Bell Apartments in Seattle, WA. Explore our one, studio, and two-bedroom floor plans today!",
  "property_seo_title_faqs": "FAQs | Apartments in Seattle, WA",
  "property_seo_description_faqs": "Find answers to your questions about 206 Bell Apartments in Seattle! From floor plans to amenities, our FAQs uncover what makes our community unique.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Seattle, WA",
  "property_seo_description_reviews": "Join the vibrant life at 206 Bell Apartments in Seattle! See what our residents love about our stunning views, amenities, and community vibe!",
  "property_seo_title_applynow": "Apply Now | Apartments in Seattle, WA",
  "property_seo_description_applynow": "Live the Seattle life at 206 Bell Apartments! Enjoy stunning views, modern amenities, and diverse floor plans. Apply now and step into your new home!",
  "property_seo_title_residentaccess": "Resident Access | 206 Bell Apartments",
  "property_seo_description_residentaccess": "Effortlessly manage your life at 206 Bell Apartments in Seattle. Log in to your resident portal for rent payments, maintenance requests, and community updates!",
  "property_seo_title_referafriend": "Refer A Friend | 206 Bell Apartments",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to 206 Bell Apartments in Seattle and enjoy the perks of community living together. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | 206 Bell Apartments",
  "property_seo_description_scheduletour": "Discover vibrant Seattle living at 206 Bell Apartments. Schedule a tour today to find your ideal urban retreat with modern amenities and views!",
  "property_seo_title_privacy": "Privacy Policy | 206 Bell Apartments",
  "property_seo_description_privacy": "Ensure your peace of mind at 206 Bell Apartments. Learn how we protect your privacy in Seattle. Your trust matters—view our comprehensive privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | 206 Bell Apartments",
  "property_seo_description_accessibility": "At 206 Bell Apartments in Seattle, we prioritize accessibility for all. Experience inclusive living with tailored solutions designed for your comfort and ease.",
  "property_seo_title_sitemap": "Sitemap | 206 Bell Apartments",
  "property_seo_description_sitemap": "Navigate 206 Bell Apartments in Seattle, WA, with our comprehensive sitemap. Discover layouts, amenities, and the vibrant community awaiting you!",
  "property_seo_title_thankyou": "Thank You | 206 Bell Apartments",
  "property_seo_description_thankyou": "Thank you for your interest in 206 Bell Apartments! Our team will reach out soon to guide you towards your new Seattle home sweet home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Seattle, WA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793119463081",
  "amenities": [
    {
      "id": "ec_ca1e06d43932c212456e0742",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007402",
      "title": "State of-the-Art Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022d-5f1e-72de-bb93-490f5434f24c.webp",
      "amenity_image_media": {
        "alt_text": "Treadmills, ellipticals, and weight machines in a modern fitness center.",
        "public_id": "019d022d-5f1e-72de-bb93-490f5434f24c",
        "storage_key": "property/6767906449167306/019d022d-5f1e-72de-bb93-490f5434f24c.webp",
        "width": 1038,
        "height": 692
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_33a1c973ebaa848068eb4d09",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "111843422",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0dcf67e99b5ddd70870a9fc7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007400",
      "title": "Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc9bbd78ebce561bafd5cb52",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007406",
      "title": "Reserved Garage Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_04ea1d4f381c2780433738eb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007401",
      "title": "Roof Top Terrace with Sweeping City & Puget Sound Views",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/01a04aaf-0d4e-70bb-b78d-1bde90e79a01.webp",
      "amenity_image_media": {
        "alt_text": "Rooftop deck with city and water views at sunset, featuring lounge chairs, tables, and grills.",
        "public_id": "01a04aaf-0d4e-70bb-b78d-1bde90e79a01",
        "storage_key": "property/6767906449167306/01a04aaf-0d4e-70bb-b78d-1bde90e79a01.webp",
        "width": 1038,
        "height": 692
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be40ae47e493551256908534",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007394",
      "title": "Gas firepit and grilling area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/01a04aaf-0db7-72cf-b02e-3c6bc50c3490.webp",
      "amenity_image_media": {
        "alt_text": "Rooftop deck with seating, grills, and a fire pit overlooking the water at sunset.",
        "public_id": "01a04aaf-0db7-72cf-b02e-3c6bc50c3490",
        "storage_key": "property/6767906449167306/01a04aaf-0db7-72cf-b02e-3c6bc50c3490.webp",
        "width": 1038,
        "height": 692
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_109836f3b2c65b5365601e48",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007395",
      "title": "Billiards Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022d-5982-77c8-b768-f0fa09d6ec45.webp",
      "amenity_image_media": {
        "alt_text": "Community lounge with a pool table, foosball table, seating area, and kitchenette.",
        "public_id": "019d022d-5982-77c8-b768-f0fa09d6ec45",
        "storage_key": "property/6767906449167306/019d022d-5982-77c8-b768-f0fa09d6ec45.webp",
        "width": 1038,
        "height": 692
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53d77b511bbc66642c2f50dc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007408",
      "title": "Covered Sky lounge with big screen TV",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022d-506a-769d-b317-c639b93e1d15.webp",
      "amenity_image_media": {
        "alt_text": "Rooftop patio with seating areas, lounge chairs, and city views at sunset.",
        "public_id": "019d022d-506a-769d-b317-c639b93e1d15",
        "storage_key": "property/6767906449167306/019d022d-506a-769d-b317-c639b93e1d15.webp",
        "width": 1037,
        "height": 692
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7a3f0817d1233ef0a21bfb09",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007399",
      "title": "Additional Storage On-Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022d-6f22-728d-b5ba-0d21fe241871.webp",
      "amenity_image_media": {
        "alt_text": "Hallway with multiple storage unit doors.",
        "public_id": "019d022d-6f22-728d-b5ba-0d21fe241871",
        "storage_key": "property/6767906449167306/019d022d-6f22-728d-b5ba-0d21fe241871.webp",
        "width": 1146,
        "height": 692
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc309f4c511ee77402dced3e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "114403491",
      "title": "EV Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/01a04aaf-102f-734d-8cfb-3b648c623ad9.webp",
      "amenity_image_media": {
        "alt_text": "Electric vehicle charging station in parking garage with signage.",
        "public_id": "01a04aaf-102f-734d-8cfb-3b648c623ad9",
        "storage_key": "property/6767906449167306/01a04aaf-102f-734d-8cfb-3b648c623ad9.webp",
        "width": 897,
        "height": 692
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2105797793b24680b2a35dc0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "111843423",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_33c15bb43c0f1edde3e83715",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007405",
      "title": "Easy Access to I5, 99, 520 & I90",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c0e120504388e6c337fecaf2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007407",
      "title": "Valet Dry Cleaning",
      "amount": "false",
      "description": "through Bakkers Fine Dry Cleaning",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_539b68ae7d5cff7651d67bc3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007409",
      "title": "Free Bike Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dcd2e246b9b3f6ce1adb51ed",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007411",
      "title": "Resident Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_95620703a445c3e4e5d964aa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007412",
      "title": "Wi-Fi Hot Spots",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_32564207ea5bba548467f229",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007410",
      "title": "Accepts Electronic Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6928afa2b6257b662fb67f0d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "124799694",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_89caa4db07d551a9ab672362",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007425",
      "title": "Full Size Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2d424670dd3f1d0a986684c5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007419",
      "title": "Floating Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bafe8ca6c816b6ae762b7dd3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007420",
      "title": "Air Conditioner Hookups*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4644241e42cca8bb80679811",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007424",
      "title": "Private Balcony*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b458b70d4aa72371c8a6b8cd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007440",
      "title": "Walk-In Closet*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b1d9116abe0c5e5cfedc870",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007416",
      "title": "Cable or Satellite",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1c643a1791fd9b22e0d7a9f9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007422",
      "title": "City, Mountain & Water Views*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_624f114ebac8b3fe5cb0121f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007413",
      "title": "Stainless Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022d-153f-721c-950f-5cfded813065.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and ample cabinet space.",
        "public_id": "019d022d-153f-721c-950f-5cfded813065",
        "storage_key": "property/6767906449167306/019d022d-153f-721c-950f-5cfded813065.webp",
        "width": 1038,
        "height": 692
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6fc2e69d8589cbdff66b1aae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007415",
      "title": "Breakfast Bar*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/01a04aaf-0da6-7228-84df-e6a5631ec1b4.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen and living area with large windows",
        "public_id": "01a04aaf-0da6-7228-84df-e6a5631ec1b4",
        "storage_key": "property/6767906449167306/01a04aaf-0da6-7228-84df-e6a5631ec1b4.webp",
        "width": 1050,
        "height": 692
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3bcbcf7336729ab90cf2c696",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007439",
      "title": "Glass Top Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c380021e1e77350794e7b7c1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007423",
      "title": "Undermount Sinks",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f2b7d5ac3605a6bd2b5d0f7f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007418",
      "title": "Key Fob Entry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4f1d57616cd0996d7140d3ae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "112007428",
      "title": "Ample Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2acab07dd913ccd3b8879ad6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "127863725",
      "title": "Accessible",
      "amount": "false",
      "description": "Accessible",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_38a67fc56b633cbb6bed3ed9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "127863726",
      "title": "Corner Unit",
      "amount": "false",
      "description": "Corner Unit",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5951e346870f7ddb79931c4f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "128006114",
      "title": "2nd Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0fd211050f8a3529a1c6dd5d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "128006094",
      "title": "3rd Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_92c2b1dda0067c7d9ff891c1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "128006095",
      "title": "4th Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_73a6f6c0a19f9fa13cde9e4e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "127863733",
      "title": "5th Floor",
      "amount": "false",
      "description": "Floor Level 5",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7630adec761903a8c23121dd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "127863734",
      "title": "6th Floor",
      "amount": "false",
      "description": "Floor Level 6",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_12a5355c95a37d15414b4e35",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "127863735",
      "title": "7th Floor",
      "amount": "false",
      "description": "Floor Level 7",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_34622a488184ede88b817ee5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "127863737",
      "title": "8th Floor",
      "amount": "false",
      "description": "Floor Level 8",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2538a798c993b3d8d985fccf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "yardi",
      "external_id": "127863775",
      "title": "Walk-in Closet",
      "amount": "false",
      "description": "Walk-in Closet",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_cedbd5ef9b7278c8300cecff",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022d-7dff-7767-bc8e-e6cd93eeef28.webp",
      "image_media": {
        "alt_text": "Building exterior with signage '206 Bell'",
        "public_id": "019d022d-7dff-7767-bc8e-e6cd93eeef28",
        "storage_key": "property/6767906449167306/019d022d-7dff-7767-bc8e-e6cd93eeef28.webp",
        "width": 2560,
        "height": 1468
      },
      "title": "Community",
      "description": "Exterior view of the 206 Bell apartment building, showcasing its modern architecture and prominent signage.",
      "link": "false",
      "alt_text": "Building exterior with signage '206 Bell'",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Weidner-Washington-206-Bell_Exterior_Building-Sign.jpg"
    },
    {
      "id": "ec_56c8850c51fbe533de462e2a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022d-76cf-720c-8671-82ac95a976cd.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with colorful facade and large windows.",
        "public_id": "019d022d-76cf-720c-8671-82ac95a976cd",
        "storage_key": "property/6767906449167306/019d022d-76cf-720c-8671-82ac95a976cd.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Discover vibrant urban living in this contemporary apartment building featuring a striking, multi-colored facade and expansive windows.",
      "link": "false",
      "alt_text": "Modern apartment building exterior with colorful facade and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Weidner-Washington-206-Bell_Exterior_Building.jpg"
    },
    {
      "id": "ec_123d703dc565c2984b19aba6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/01a04aad-1f06-75f1-9095-12beec2f93c2.webp",
      "image_media": {
        "alt_text": "Rooftop patio with seating, grills, and a fire pit overlooking the water at sunset.",
        "public_id": "01a04aad-1f06-75f1-9095-12beec2f93c2",
        "storage_key": "property/6767906449167306/01a04aad-1f06-75f1-9095-12beec2f93c2.webp",
        "width": 2400,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy breathtaking sunset views from our rooftop patio, complete with comfortable seating, grilling stations, and a cozy fire pit. Perfect for entertaining or relaxing.",
      "link": "false",
      "alt_text": "Rooftop patio with seating, grills, and a fire pit overlooking the water at sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/206-Bell_Amenity_Exterior_Rooftop-Lounge_2.jpg"
    },
    {
      "id": "ec_cf083bec02fbf10259e214ad",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/01a04aad-2008-74aa-a4e4-f039b45622d4.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with seating, tables, and city views at sunset.",
        "public_id": "01a04aad-2008-74aa-a4e4-f039b45622d4",
        "storage_key": "property/6767906449167306/01a04aad-2008-74aa-a4e4-f039b45622d4.webp",
        "width": 2400,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy breathtaking city views from our rooftop lounge, featuring comfortable seating, outdoor dining, and a modern ambiance perfect for relaxation or entertaining.",
      "link": "false",
      "alt_text": "Rooftop lounge area with seating, tables, and city views at sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/206-Bell_Amenity_Exterior_Rooftop-Lounge_1.jpg"
    },
    {
      "id": "ec_0ff01bba75984e8953715d45",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/01a04aad-2587-764d-86f2-8c460e4c5408.webp",
      "image_media": {
        "alt_text": "Electric vehicle charging stations in parking garage.",
        "public_id": "01a04aad-2587-764d-86f2-8c460e4c5408",
        "storage_key": "property/6767906449167306/01a04aad-2587-764d-86f2-8c460e4c5408.webp",
        "width": 3072,
        "height": 2294
      },
      "title": "Community",
      "description": "Dedicated electric vehicle charging stations available for resident use in our secure parking garage.",
      "link": "false",
      "alt_text": "Electric vehicle charging stations in parking garage.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/206-Bell_Amenity_EV-Charging.jpg"
    },
    {
      "id": "ec_b60f8bb4dd87546af2b49201",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/01a04aad-1fb0-7609-85ac-5d6e48e8e3a0.webp",
      "image_media": {
        "alt_text": "Self-storage units with orange roll-up doors.",
        "public_id": "01a04aad-1fb0-7609-85ac-5d6e48e8e3a0",
        "storage_key": "property/6767906449167306/01a04aad-1fb0-7609-85ac-5d6e48e8e3a0.webp",
        "width": 2400,
        "height": 1792
      },
      "title": "Community",
      "description": "Secure and spacious self-storage units available for rent, featuring convenient roll-up doors.",
      "link": "false",
      "alt_text": "Self-storage units with orange roll-up doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/206-Bell_Amenity_Storage.jpg"
    },
    {
      "id": "ec_a8fe84697d7b5a346eb169a4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022d-5c12-703f-a3df-d13d1f7e8f53.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, weight machine, and stability balls.",
        "public_id": "019d022d-5c12-703f-a3df-d13d1f7e8f53",
        "storage_key": "property/6767906449167306/019d022d-5c12-703f-a3df-d13d1f7e8f53.webp",
        "width": 1038,
        "height": 692
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines, strength training equipment, and yoga balls.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, ellipticals, weight machine, and stability balls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/p1622692_206Bell_10_PhotoGallery.jpg"
    },
    {
      "id": "ec_578c7facaf38fc732bded88e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022d-5982-77c8-b768-f0fa09d6ec45.webp",
      "image_media": {
        "alt_text": "Community lounge with a pool table, foosball table, seating area, and kitchenette.",
        "public_id": "019d022d-5982-77c8-b768-f0fa09d6ec45",
        "storage_key": "property/6767906449167306/019d022d-5982-77c8-b768-f0fa09d6ec45.webp",
        "width": 1038,
        "height": 692
      },
      "title": "Community",
      "description": "Enjoy leisure time in our community lounge, featuring a pool table, foosball, and a convenient kitchenette.",
      "link": "false",
      "alt_text": "Community lounge with a pool table, foosball table, seating area, and kitchenette.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/p1622692_206Bell_04_PhotoGallery.jpg"
    },
    {
      "id": "ec_89ecfea18145f262f3a35182",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/01a04aad-1eee-73a9-b687-2044acf85e02.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, lamps, closet, and artwork.",
        "public_id": "01a04aad-1eee-73a9-b687-2044acf85e02",
        "storage_key": "property/6767906449167306/01a04aad-1eee-73a9-b687-2044acf85e02.webp",
        "width": 2400,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Chic and modern bedroom featuring a comfortable king-size bed, stylish nightstands with lamps, and ample closet space for storage. Accent artwork adds a touch of sophistication.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, nightstands, lamps, closet, and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/p1622692_206Bell_03_PhotoGallery(1).jpg"
    },
    {
      "id": "ec_592af04e781a0b646e52551d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/01a04aad-3500-757d-9a49-2e6553006fac.webp",
      "image_media": {
        "alt_text": "Living room with a blue sofa, armchair, coffee tables, TV, and a framed soccer jersey.",
        "public_id": "01a04aad-3500-757d-9a49-2e6553006fac",
        "storage_key": "property/6767906449167306/01a04aad-3500-757d-9a49-2e6553006fac.webp",
        "width": 2400,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable blue sofa, modern furniture, a flat-screen TV, and unique decor like a framed soccer jersey.",
      "link": "false",
      "alt_text": "Living room with a blue sofa, armchair, coffee tables, TV, and a framed soccer jersey.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/206-Bell_Livingroom_1.jpg"
    },
    {
      "id": "ec_13edf138e9586f78bf38db62",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/01a04aad-342d-731f-a9ed-5c333082ecef.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen area with blue sofa, wooden cabinets, and stainless steel appliances.",
        "public_id": "01a04aad-342d-731f-a9ed-5c333082ecef",
        "storage_key": "property/6767906449167306/01a04aad-342d-731f-a9ed-5c333082ecef.webp",
        "width": 2400,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Stylish open-concept living space featuring a comfortable blue sofa, a modern kitchen with sleek cabinetry, and a dining nook.",
      "link": "false",
      "alt_text": "Modern living room and kitchen area with blue sofa, wooden cabinets, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/p1622692_206Bell_13_PhotoGallery(1).jpg"
    },
    {
      "id": "ec_c62997d460d1f8ad3ee4c415",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/01a04aad-34cb-718b-960b-427606d49611.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and wood cabinetry.",
        "public_id": "01a04aad-34cb-718b-960b-427606d49611",
        "storage_key": "property/6767906449167306/01a04aad-34cb-718b-960b-427606d49611.webp",
        "width": 2400,
        "height": 1792
      },
      "title": "Apartment",
      "description": "View of a spacious apartment kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and wood cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/206-Bell_Kitchen.jpg"
    },
    {
      "id": "ec_e991bd7c42d3ef51a6b86352",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/01a04aad-37fd-7577-96d9-d58418990ddb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
        "public_id": "01a04aad-37fd-7577-96d9-d58418990ddb",
        "storage_key": "property/6767906449167306/01a04aad-37fd-7577-96d9-d58418990ddb.webp",
        "width": 2400,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment kitchen featuring sleek stainless steel appliances, elegant granite countertops, and rich dark wood cabinetry, perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/p1622692_206Bell_12_PhotoGallery(1).jpg"
    },
    {
      "id": "ec_19561b168ea9ae1fafb70126",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/01a04aad-3da9-71e9-b0ec-954fbb115c50.webp",
      "image_media": {
        "alt_text": "Empty living room with large windows and city views.",
        "public_id": "01a04aad-3da9-71e9-b0ec-954fbb115c50",
        "storage_key": "property/6767906449167306/01a04aad-3da9-71e9-b0ec-954fbb115c50.webp",
        "width": 2400,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Bright and airy living room with hardwood floors and floor-to-ceiling windows offering panoramic city views.",
      "link": "false",
      "alt_text": "Empty living room with large windows and city views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/206-Bell_Livingroom_2.jpg"
    },
    {
      "id": "ec_d1d6016b6055aba8aafade10",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/01a04aad-464d-7515-9924-14773dbd64d4.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen and living area with large windows and city views.",
        "public_id": "01a04aad-464d-7515-9924-14773dbd64d4",
        "storage_key": "property/6767906449167306/01a04aad-464d-7515-9924-14773dbd64d4.webp",
        "width": 2400,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Experience urban living in this stylish apartment featuring a gourmet kitchen and an open-concept living space with stunning city and water vistas.",
      "link": "false",
      "alt_text": "Modern apartment kitchen and living area with large windows and city views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/p1622692_206Bell_01_PhotoGallery(2).jpg"
    },
    {
      "id": "ec_ccd2da22a3995d3daf708f97",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/01a04aad-4838-745a-8406-05fc074a1498.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, two closets, and decorative wall art.",
        "public_id": "01a04aad-4838-745a-8406-05fc074a1498",
        "storage_key": "property/6767906449167306/01a04aad-4838-745a-8406-05fc074a1498.webp",
        "width": 2400,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Bright and airy bedroom featuring a comfortable queen-size bed, ample closet space, and stylish decor.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, two closets, and decorative wall art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/206-Bell_Bedroom.jpg"
    },
    {
      "id": "ec_f8c68aae087f03335cfc03e3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/01a04aad-4901-756f-86bc-517ecbc8d6e5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops, overlooking a scenic view.",
        "public_id": "01a04aad-4901-756f-86bc-517ecbc8d6e5",
        "storage_key": "property/6767906449167306/01a04aad-4901-756f-86bc-517ecbc8d6e5.webp",
        "width": 2400,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring stainless steel appliances, sleek granite countertops, and ample cabinet space. Enjoy cooking with a view!",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops, overlooking a scenic view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/p1622692_206Bell_02_PhotoGallery(2).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_aabf304c-8204-4930-a5b4-66d956c90507",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Din Tai Fung 鼎泰豐",
      "poi_type": "Restaurants",
      "poi_address": "600 Pine St, Seattle, WA 98101, USA",
      "poi_short_description": "Relaxed Taiwanese chain featuring hand-pulled noodles, xiaolongbao dumplings and other regional dishes.",
      "poi_long_description": "People say this Chinese restaurant serves delicious soup dumplings, spicy wontons, and garlic green beans. They highlight the fresh flavors, generous portions, and the chocolate dumplings for dessert. They also like the fast service and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-854f-7318-a34c-b4a6a24b3e6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-854f-7318-a34c-b4a6a24b3e6e",
        "storage_key": "property/6767906449167306/019d022e-854f-7318-a34c-b4a6a24b3e6e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dtf.com/en/locations/seattle-pacific-place",
      "poi_directions_map_url": "https://maps.google.com/?cid=4829861873643955218&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "din-tai-fung-",
      "poi_latitude": "47.6126501",
      "poi_longitude": "-122.335168",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-682-9888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f25-779d-9b59-7e0684cabfe8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f25-779d-9b59-7e0684cabfe8",
        "storage_key": "property/6767906449167306/019d022e-4f25-779d-9b59-7e0684cabfe8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPemT0bRqkFQREiTAzMgdB0M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "taiwanese_restaurant"
    },
    {
      "id": "custom_02afdf45-98fa-48da-81c8-d9536b818e64",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Dave's Hot Chicken",
      "poi_type": "Restaurants",
      "poi_address": "1200 E Pike St Suite No. 2, Seattle, WA 98122, USA",
      "poi_short_description": "Nashville-style chicken shop serving tenders, burgers, sliders and milkshakes.",
      "poi_long_description": "People say this chicken restaurant serves delicious Nashville-style hot chicken sliders, tenders, and sandwiches, with a variety of spice levels. They highlight the generous portions, reasonable prices, and fun, energetic vibe. They also like the fast service and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-8577-70fd-b834-88d31718d2c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-8577-70fd-b834-88d31718d2c7",
        "storage_key": "property/6767906449167306/019d022e-8577-70fd-b834-88d31718d2c7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://restaurants.daveshotchicken.com/wa/seattle/spicy-chicken-sandwich-on-east-pike-street/?utm_campaign=google_maps&utm_medium=organic&utm_source=google&utm_content=website&utm_keyword=1205",
      "poi_directions_map_url": "https://maps.google.com/?cid=4892726209442789638&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "daves-hot-chicken",
      "poi_latitude": "47.6142778",
      "poi_longitude": "-122.3165507",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-813-2924",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f25-779d-9b59-7e0684cabfe8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f25-779d-9b59-7e0684cabfe8",
        "storage_key": "property/6767906449167306/019d022e-4f25-779d-9b59-7e0684cabfe8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJic7fXWVrkFQRBrkUkZB05kM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "custom_757e5d11-0dd9-4a57-8b5c-94faca5e5ba5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "The Pink Door",
      "poi_type": "Restaurants",
      "poi_address": "1919 Post Alley, Seattle, WA 98101, USA",
      "poi_short_description": "Italian restaurant with cabaret shows and trapeze entertainment, plus terrace with Elliott Bay views.",
      "poi_long_description": "People say this Italian restaurant serves delicious arancini, cioppino, and squid ink pasta. They highlight the fresh seafood, flavorful sauces, and the option to sit at the bar. They also like the attentive staff and the lively atmosphere with live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022d-f55b-72af-b40f-b1906782c809.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022d-f55b-72af-b40f-b1906782c809",
        "storage_key": "property/6767906449167306/019d022d-f55b-72af-b40f-b1906782c809.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.thepinkdoor.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13451524338311652394&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-pink-door",
      "poi_latitude": "47.6103652",
      "poi_longitude": "-122.3425604",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-443-3241",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f25-779d-9b59-7e0684cabfe8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f25-779d-9b59-7e0684cabfe8",
        "storage_key": "property/6767906449167306/019d022e-4f25-779d-9b59-7e0684cabfe8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ91YOzrJqkFQRKmSW0B1qrbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_0dadcd35-6619-4f84-8d48-c5b2a51a5699",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Von's 1000Spirits",
      "poi_type": "Restaurants",
      "poi_address": "1225 1st Ave, Seattle, WA 98101, USA",
      "poi_short_description": "Casual dining on burgers, pizza & bar food in a tavern space showcasing a massive booze selection.",
      "poi_long_description": "People say this restaurant serves delicious sourdough pasta, pizza, and burgers. They highlight the great cocktails, lively atmosphere, and generous portions. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-8593-74c5-8be5-02514127facf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-8593-74c5-8be5-02514127facf",
        "storage_key": "property/6767906449167306/019d022e-8593-74c5-8be5-02514127facf.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.vons1000spirits.com/?utm_source=gmb&utm_medium=organic&utm_campaign=gmbpost",
      "poi_directions_map_url": "https://maps.google.com/?cid=5056199159300483347&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vons-1000spirits",
      "poi_latitude": "47.6066052",
      "poi_longitude": "-122.3384085",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-621-8667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f25-779d-9b59-7e0684cabfe8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f25-779d-9b59-7e0684cabfe8",
        "storage_key": "property/6767906449167306/019d022e-4f25-779d-9b59-7e0684cabfe8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYSjPILJqkFQRE-m7s1g6K0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_0fb0042f-7475-4e3c-bca3-598020bde3b5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Dick's Drive-In",
      "poi_type": "Restaurants",
      "poi_address": "115 Broadway E, Seattle, WA 98102, USA",
      "poi_short_description": "Long-running fast-food chain with a cult following for its homemade fries, burgers & shakes.",
      "poi_long_description": "People say this fast food restaurant serves tasty burgers, fries, and shakes. They also highlight the affordable prices, quick service, and friendly staff.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-86ad-7544-b29b-a54f734b6769.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-86ad-7544-b29b-a54f734b6769",
        "storage_key": "property/6767906449167306/019d022e-86ad-7544-b29b-a54f734b6769.webp",
        "width": 1280,
        "height": 912
      },
      "poi_business_url": "http://www.ddir.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17975972120156224243&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dicks-drive-in",
      "poi_latitude": "47.6193263",
      "poi_longitude": "-122.3212263",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-323-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f25-779d-9b59-7e0684cabfe8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f25-779d-9b59-7e0684cabfe8",
        "storage_key": "property/6767906449167306/019d022e-4f25-779d-9b59-7e0684cabfe8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6cIFkjIVkFQR87o8Cmd7d_k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_6a3e8acf-a0f7-467b-9668-8df6c365a0c1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "University Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "2623 NE University Village St, Seattle, WA 98105, USA",
      "poi_short_description": "Al fresco shopping center since the 1950s, with local stores, well-known brands & dining options.",
      "poi_long_description": "People say this shopping center offers a wide selection of shops, restaurants, and a grocery store. They highlight the fun, walkable, and safe atmosphere, as well as the free parking and clean, well-maintained grounds. They also like the outdoor seating, umbrellas, and small playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-89b7-73bc-b64a-7e18e7be8a73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-89b7-73bc-b64a-7e18e7be8a73",
        "storage_key": "property/6767906449167306/019d022e-89b7-73bc-b64a-7e18e7be8a73.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://uvillage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4185780485491805676&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-village",
      "poi_latitude": "47.6616885",
      "poi_longitude": "-122.2990339",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 206-523-0622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f61-71a3-8830-47d687d06800.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f61-71a3-8830-47d687d06800",
        "storage_key": "property/6767906449167306/019d022e-4f61-71a3-8830-47d687d06800.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2_IcB4YUkFQR7E2AoSzhFjo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_3f78cd2a-cad7-48ab-9d4b-abe327004ca6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2210 Westlake Ave N, Seattle, WA 98121, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, delicious baked goods, and a great salad bar. They also highlight the friendly and helpful staff, the spacious and clean environment, and the convenient location with ample parking.\n\nSome reviews mention the prices can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-0397-72b9-a00c-a959330ac409.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-0397-72b9-a00c-a959330ac409",
        "storage_key": "property/6767906449167306/019d022e-0397-72b9-a00c-a959330ac409.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/westlake?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=13331991485400734650&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "47.6183573",
      "poi_longitude": "-122.3380162",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-621-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f25-779d-9b59-8072768e9380.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f25-779d-9b59-8072768e9380",
        "storage_key": "property/6767906449167306/019d022e-4f25-779d-9b59-8072768e9380.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyz9g9EkVkFQRutvXu56_BLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_81210d0d-514e-49d9-915e-ee39f4fe21a9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Uwajimaya Seattle",
      "poi_type": "Shopping & Retail",
      "poi_address": "600 5th Ave S, Seattle, WA 98104, USA",
      "poi_short_description": "Perennial Asian grocery stocking meats, produce & prepared foods, plus gifts & home goods.",
      "poi_long_description": "People say this Asian grocery store offers a wide selection of fresh produce, seafood, and specialty Asian ingredients, as well as a variety of prepared foods, snacks, and pantry staples. They highlight the reasonable prices, convenient parking, and the fun, cultural experience, including a food court and bookstore. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-89a8-7646-950b-12b4ac0d359a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-89a8-7646-950b-12b4ac0d359a",
        "storage_key": "property/6767906449167306/019d022e-89a8-7646-950b-12b4ac0d359a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.uwajimaya.com/visit/seattle/?utm_source=localprofiles&utm_medium=organic&utm_content=seattle&utm_campaign=fm",
      "poi_directions_map_url": "https://maps.google.com/?cid=18369564176154316475&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uwajimaya-seattle",
      "poi_latitude": "47.5968404",
      "poi_longitude": "-122.3267453",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-624-6248",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f25-779d-9b59-8072768e9380.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f25-779d-9b59-8072768e9380",
        "storage_key": "property/6767906449167306/019d022e-4f25-779d-9b59-8072768e9380.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq9nX27xqkFQRu05rxkrN7f4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_07ee518f-11ad-4cd5-9da6-392dfd003941",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1700 E Madison St, Seattle, WA 98122, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide variety of unique products, including fresh produce, bakery items, and prepackaged meals. They highlight the reasonable prices, especially for produce and wine, and the fun, pleasant atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-8b26-748f-a947-dca8bb14afce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-8b26-748f-a947-dca8bb14afce",
        "storage_key": "property/6767906449167306/019d022e-8b26-748f-a947-dca8bb14afce.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.traderjoes.com/wa/seattle/130/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5748370317872008118&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "47.61582569999999",
      "poi_longitude": "-122.309937",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-322-7268",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f25-779d-9b59-8072768e9380.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f25-779d-9b59-8072768e9380",
        "storage_key": "property/6767906449167306/019d022e-4f25-779d-9b59-8072768e9380.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx0M1ztNqkFQRtgspEllQxk8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_66a2a3fb-93c3-414d-8f70-0214d157f14f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "University of Washington",
      "poi_type": "Education",
      "poi_address": "1410 NE Campus Pkwy, Seattle, WA 98195, USA",
      "poi_short_description": "This 1861 research school in Downtown Seattle is known for medicine, engineering & business.",
      "poi_long_description": "This 1861 research school in Downtown Seattle is known for medicine, engineering & business.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-460d-743e-a749-0420eeacf84a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-460d-743e-a749-0420eeacf84a",
        "storage_key": "property/6767906449167306/019d022e-460d-743e-a749-0420eeacf84a.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://www.washington.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7742862557588237219&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-washington",
      "poi_latitude": "47.6565919",
      "poi_longitude": "-122.3126783",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 206-543-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-5236-7243-9797-6aa92d2da5ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-5236-7243-9797-6aa92d2da5ed",
        "storage_key": "property/6767906449167306/019d022e-5236-7243-9797-6aa92d2da5ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6zWFnZIUkFQRoyu4AXksdGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_77ba89c1-ab60-4d5f-8153-f477139e1bca",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Seattle Public Library - Central Library",
      "poi_type": "Education",
      "poi_address": "1000 4th Ave, Seattle, WA 98104, USA",
      "poi_short_description": "Dramatic, view-filled facility lending books, films & music, plus numerous public computers.",
      "poi_long_description": "Visitors say this public library offers a wide variety of books, computers, and study spaces, and they praise its stunning, modern architecture. They also highlight the friendly staff and the peaceful atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-8e33-76ff-b436-8e570ea553c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-8e33-76ff-b436-8e570ea553c6",
        "storage_key": "property/6767906449167306/019d022e-8e33-76ff-b436-8e570ea553c6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.spl.org/hours-and-locations/central-library",
      "poi_directions_map_url": "https://maps.google.com/?cid=12943420815159197138&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seattle-public-library---central-library",
      "poi_latitude": "47.6066621",
      "poi_longitude": "-122.3321837",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-386-4636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-5236-7243-9797-6aa92d2da5ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-5236-7243-9797-6aa92d2da5ed",
        "storage_key": "property/6767906449167306/019d022e-5236-7243-9797-6aa92d2da5ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ55fLWVtBkFQR0v31eadEoLM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_d8e60ac9-1b30-4cde-946d-23dd96e9cd40",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Seattle Central College",
      "poi_type": "Education",
      "poi_address": "1701 Broadway, Seattle, WA 98122, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-1107-77dd-9f6e-454d1a2be1ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-1107-77dd-9f6e-454d1a2be1ca",
        "storage_key": "property/6767906449167306/019d022e-1107-77dd-9f6e-454d1a2be1ca.webp",
        "width": 1280,
        "height": 810
      },
      "poi_business_url": "https://seattlecentral.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15860090414231206236&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seattle-central-college",
      "poi_latitude": "47.6167229",
      "poi_longitude": "-122.3215965",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-934-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-5236-7243-9797-6aa92d2da5ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-5236-7243-9797-6aa92d2da5ed",
        "storage_key": "property/6767906449167306/019d022e-5236-7243-9797-6aa92d2da5ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJScFRw8xqkFQRXDnUjTNcGtw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e77671d5-79ce-4ede-9fe2-95af6bd53be1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Seattle University",
      "poi_type": "Education",
      "poi_address": "901 12th Ave, Seattle, WA 98122, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-125d-775f-9a51-ca180d9ed15f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-125d-775f-9a51-ca180d9ed15f",
        "storage_key": "property/6767906449167306/019d022e-125d-775f-9a51-ca180d9ed15f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.seattleu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4887710188514951233&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seattle-university",
      "poi_latitude": "47.6091765",
      "poi_longitude": "-122.3178465",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-296-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-5236-7243-9797-6aa92d2da5ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-5236-7243-9797-6aa92d2da5ed",
        "storage_key": "property/6767906449167306/019d022e-5236-7243-9797-6aa92d2da5ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoZv0y8hqkFQRQcB9L4Wi1EM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7771a73c-32ab-448a-a40c-76e4b484ad64",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "North Seattle College",
      "poi_type": "Education",
      "poi_address": "9600 College Way N, Seattle, WA 98103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-90c9-77ca-8d3f-51a6393bbb58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-90c9-77ca-8d3f-51a6393bbb58",
        "storage_key": "property/6767906449167306/019d022e-90c9-77ca-8d3f-51a6393bbb58.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://northseattle.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=404283079753513623&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "north-seattle-college",
      "poi_latitude": "47.6989479",
      "poi_longitude": "-122.3326717",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 206-934-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-5236-7243-9797-6aa92d2da5ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-5236-7243-9797-6aa92d2da5ed",
        "storage_key": "property/6767906449167306/019d022e-5236-7243-9797-6aa92d2da5ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVVWVdQEUkFQRl7porVFNnAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_518c1d4a-c733-4874-9486-bbe68bb6e688",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "T-Mobile Park",
      "poi_type": "Entertainment",
      "poi_address": "1250 1st Ave S, Seattle, WA 98134, USA",
      "poi_short_description": "Seattle Mariners' ballpark with city skyline views, lots of stadium eats & a retractable roof.",
      "poi_long_description": "People say this stadium offers exciting baseball games, concerts, and fireworks shows, with a retractable roof and views of the city skyline. They highlight the electric atmosphere, family-friendly vibe, and convenient parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-912d-73d4-8af5-6910b24deefa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-912d-73d4-8af5-6910b24deefa",
        "storage_key": "property/6767906449167306/019d022e-912d-73d4-8af5-6910b24deefa.webp",
        "width": 1242,
        "height": 540
      },
      "poi_business_url": "http://seattle.mariners.mlb.com/sea/ballpark/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14337255265305820565&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "t-mobile-park",
      "poi_latitude": "47.591472",
      "poi_longitude": "-122.3325832",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-346-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-b62a-720c-bb30-888e5088ec9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-b62a-720c-bb30-888e5088ec9f",
        "storage_key": "property/6767906449167306/019d022e-b62a-720c-bb30-888e5088ec9f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ28RdUJ9qkFQRlf2mprMp-MY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_0737ab54-efd3-45d4-abf0-27d5e7e3428f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Climate Pledge Arena",
      "poi_type": "Entertainment",
      "poi_address": "334 1st Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Large venue hosts WNBA & NCAA basketball, roller derby, concerts & events for up to 17,000 people.",
      "poi_long_description": "People say this arena offers a variety of food and drink options, and is a great place to watch hockey games and concerts. They highlight the modern design, clean facilities, and great acoustics. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-91a2-7548-a14f-e1e106ad3fb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-91a2-7548-a14f-e1e106ad3fb1",
        "storage_key": "property/6767906449167306/019d022e-91a2-7548-a14f-e1e106ad3fb1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://climatepledgearena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15998104634649095719&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "climate-pledge-arena",
      "poi_latitude": "47.622094",
      "poi_longitude": "-122.353984",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-752-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f28-713c-82ca-ccb5ef2adf99",
        "storage_key": "property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ046-cUQVkFQRJy7KU2evBN4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_e489b61b-a05d-4777-9685-2a77ecbda420",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Lumen Field",
      "poi_type": "Entertainment",
      "poi_address": "800 Occidental Ave S, Seattle, WA 98134, USA",
      "poi_short_description": "Home of the Seahawks & Sounders, this 68,740-seat multipurpose stadium features skyline views.",
      "poi_long_description": "People say this stadium offers a variety of sporting events, concerts, and tours, and has a pro shop. They highlight the energetic atmosphere, the beautiful design, and the stunning views of the city and ocean. They also like the friendly staff and the smooth management of large crowds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-9254-7306-8d7f-f2295c4f13b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-9254-7306-8d7f-f2295c4f13b1",
        "storage_key": "property/6767906449167306/019d022e-9254-7306-8d7f-f2295c4f13b1.webp",
        "width": 852,
        "height": 1280
      },
      "poi_business_url": "http://www.lumenfield.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11976986007816512220&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lumen-field",
      "poi_latitude": "47.5951518",
      "poi_longitude": "-122.3316394",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-381-7555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-b62a-720c-bb30-888e5088ec9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-b62a-720c-bb30-888e5088ec9f",
        "storage_key": "property/6767906449167306/019d022e-b62a-720c-bb30-888e5088ec9f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKxjxuaNqkFQR3CK6O1HNNqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_201999ea-345e-4a0e-a72e-5cf1e4270b07",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Woodland Park Zoo",
      "poi_type": "Entertainment",
      "poi_address": "Seattle, WA 98103, USA",
      "poi_short_description": "92-acre zoo with nearly 300 species, a vintage carousel, summer concerts & an indoor play space.",
      "poi_long_description": "People say this zoo offers a wide variety of animals in spacious, naturalistic habitats, and features a fun dinosaur exhibit. They highlight the beautiful, well-maintained grounds with plenty of shade and walking paths, and the family-friendly atmosphere with interactive activities and events. They also like the friendly, knowledgeable staff and volunteers who are happy to answer questions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-95b0-716f-b187-d80303bcb672.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-95b0-716f-b187-d80303bcb672",
        "storage_key": "property/6767906449167306/019d022e-95b0-716f-b187-d80303bcb672.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.zoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8962776519554476210&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-park-zoo",
      "poi_latitude": "47.668436",
      "poi_longitude": "-122.3508786",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-548-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f28-713c-82ca-ccb5ef2adf99",
        "storage_key": "property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJydSuSkkUkFQRsqhB-cEtYnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_327eaa25-20f8-48f5-8c7c-09f9b3e80100",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Seattle Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "1483 Alaskan Way Pier 59, Seattle, WA 98101, USA",
      "poi_short_description": "Popular waterfront aquarium with interactive exhibits, a cafe & virtual reality shows.",
      "poi_long_description": "People say this aquarium offers a wide variety of marine life, including sea otters, seals, and a large ocean tank with sharks and rays. They also highlight the interactive touch pools, the informative shows, and the friendly, knowledgeable staff.\n\nOther reviews mention the admission can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-178d-74b9-932c-dd6f13e8eb96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-178d-74b9-932c-dd6f13e8eb96",
        "storage_key": "property/6767906449167306/019d022e-178d-74b9-932c-dd6f13e8eb96.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.seattleaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7753481524406941315&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seattle-aquarium",
      "poi_latitude": "47.6074002",
      "poi_longitude": "-122.3429559",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-386-4300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f28-713c-82ca-ccb5ef2adf99",
        "storage_key": "property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ_oEiK1qkFQRg3bU4l3mmWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_ebd88f89-418a-4374-9dab-35da8e6e63c7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1416 NW Ballard Way, Seattle, WA 98107, USA",
      "poi_short_description": "Sporting gym with cardio equipment, free weights and an indoor pool (open year-round), plus a sauna.",
      "poi_long_description": "People say this gym offers a wide variety of machines, including unilateral options, and has a spacious layout with plenty of equipment.\n\nOther reviews mention the equipment can be broken and the facilities can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-958b-7582-9cbb-ce2b7883c2a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-958b-7582-9cbb-ce2b7883c2a0",
        "storage_key": "property/6767906449167306/019d022e-958b-7582-9cbb-ce2b7883c2a0.webp",
        "width": 1170,
        "height": 905
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=455&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=3768693322368076231&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "47.662302",
      "poi_longitude": "-122.3755124",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-508-5030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f28-713c-82ca-ccb5ef2adf99",
        "storage_key": "property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpfJWZLcVkFQRx8ki-5sWTTQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_11f77dd1-af55-4f51-8396-b089135b2ed7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Olympic Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "5301 Leary Ave NW, Seattle, WA 98107, USA",
      "poi_short_description": "Elegant sports club with weights, cardio machines, group classes, an indoor pool, saunas & jacuzzis.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment, classes, and amenities, including a pool, sauna, and hot tub. They also highlight the spacious layout, the semi-private workout spaces, and the convenient parking.\n\nOther reviews mention the facilities can be under renovation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-96ce-762f-997a-dff212dd2224.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-96ce-762f-997a-dff212dd2224",
        "storage_key": "property/6767906449167306/019d022e-96ce-762f-997a-dff212dd2224.webp",
        "width": 1280,
        "height": 487
      },
      "poi_business_url": "http://www.olympicathleticclub.com/?utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=9243484350012506487&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "olympic-athletic-club",
      "poi_latitude": "47.6664152",
      "poi_longitude": "-122.3828324",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 206-944-3615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f28-713c-82ca-ccb5ef2adf99",
        "storage_key": "property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-6exLYVkFQRd8Fg0Qp0R4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7665173c-136a-4ac3-804c-e2461a0fcd78",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Equinox Rainier Square",
      "poi_type": "Health and Wellness",
      "poi_address": "401 Union St Suite 220, Seattle, WA 98101, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a variety of classes and the instructors are great.\n\nOther reviews mention the weightlifting area can be small and the water fountains can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-9981-7699-9ab1-c0669e2b4970.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-9981-7699-9ab1-c0669e2b4970",
        "storage_key": "property/6767906449167306/019d022e-9981-7699-9ab1-c0669e2b4970.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://equinox-spa.com/serviceGroupDetails?facilityId=790&cid=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3460855741733625954&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "equinox-rainier-square",
      "poi_latitude": "47.6092692",
      "poi_longitude": "-122.335354",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-336-0260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f28-713c-82ca-ccb5ef2adf99",
        "storage_key": "property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK5aexv1rkFQRYmDn8PVtBzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_71536a39-efe3-423b-ac2c-15f1b5c16421",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1500 NW Market St Ste 100, Seattle, WA 98107, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this fitness center offers a wide variety of machines and equipment, and the staff is friendly and helpful.\n\nOther reviews mention the facilities can be crowded and the temperature can be hot.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-9b0e-733e-9118-ac4bc3f12959.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-9b0e-733e-9118-ac4bc3f12959",
        "storage_key": "property/6767906449167306/019d022e-9b0e-733e-9118-ac4bc3f12959.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/?utm_medium=yext&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=18000937299387102910&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "47.668813",
      "poi_longitude": "-122.3773675",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-260-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f28-713c-82ca-ccb5ef2adf99",
        "storage_key": "property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1WjAVG8VkFQRvjYMyhkt0Pk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_a454cf16-c42d-427b-af5e-b1bd17e82ac5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Barry's Seattle",
      "poi_type": "Health and Wellness",
      "poi_address": "112 Westlake Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Chains for group training in the Red Room on treadmills, interspersed with bench exercises.",
      "poi_long_description": "People say this fitness center offers a challenging workout that combines cardio, strength, weights, resistance, stretching, and agility. They highlight the fun music, high energy, and positive vibe. They also like the motivational and encouraging instructors. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-9b16-74ef-8469-a1ccb4c4297c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-9b16-74ef-8469-a1ccb4c4297c",
        "storage_key": "property/6767906449167306/019d022e-9b16-74ef-8469-a1ccb4c4297c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.barrys.com/studio/seattle",
      "poi_directions_map_url": "https://maps.google.com/?cid=1874324567168923080&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "barrys-seattle",
      "poi_latitude": "47.6188612",
      "poi_longitude": "-122.3382048",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-687-7180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f28-713c-82ca-ccb5ef2adf99",
        "storage_key": "property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq8epeK8VkFQRyDXkY0PwAho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_4da97ee1-053c-4acc-8300-a9cbf890a68c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "West Seattle Health Club",
      "poi_type": "Health and Wellness",
      "poi_address": "2629 SW Andover St, Seattle, WA 98126, USA",
      "poi_short_description": "Swimming, spacious gym featuring a rock-climbing wall and a heated pool.",
      "poi_long_description": "People say this fitness center offers a wide variety of amenities, including a pool, sauna, and jacuzzi, as well as numerous classes and workout equipment. They also highlight the friendly and helpful staff, and the clean and comfortable facilities.\n\nSome reviews mention the machines can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-9da8-72d9-9011-0237a7b83393.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-9da8-72d9-9011-0237a7b83393",
        "storage_key": "property/6767906449167306/019d022e-9da8-72d9-9011-0237a7b83393.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://westseattlehc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17611443290596558280&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "west-seattle-health-club",
      "poi_latitude": "47.5680479",
      "poi_longitude": "-122.3676256",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-556-3280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f28-713c-82ca-ccb5ef2adf99",
        "storage_key": "property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJizEFLE7YB0ERyMXxBV1qaPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_c0b0913b-7a21-4ed2-8976-94fe8c0e4574",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "[solidcore] SLU",
      "poi_type": "Health and Wellness",
      "poi_address": "2139 6th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this pilates studio offers a wide range of class times and convenient parking.\n\nOther reviews mention the membership service can be frustrating and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-9f7b-77bf-9fa4-e7854102791f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-9f7b-77bf-9fa4-e7854102791f",
        "storage_key": "property/6767906449167306/019d022e-9f7b-77bf-9fa4-e7854102791f.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.solidcore.co/wa/seattle/slu/?utm_source=google&utm_medium=search&utm_content=local-listing&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12001859543961006521&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "solidcore-slu",
      "poi_latitude": "47.6153071",
      "poi_longitude": "-122.3404108",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-594-3782",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f28-713c-82ca-ccb5ef2adf99",
        "storage_key": "property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4Vi9xnMVkFQRuXHtqaorj6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6bd7b9c2-3497-4578-a74b-ebca4efce977",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Emerald City Athletics - Wallingford",
      "poi_type": "Health and Wellness",
      "poi_address": "3924 Stone Way N, Seattle, WA 98103, USA",
      "poi_short_description": "Fitness center offering training and group classes in a spacious space.",
      "poi_long_description": "People say this gym offers a wide variety of equipment for different fitness goals, including bodybuilding, powerlifting, and Hyrox training. They highlight the clean, well-maintained facilities and the welcoming, non-judgmental atmosphere. They also like the friendly, knowledgeable, and helpful staff and trainers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-9f46-7430-af5a-a098ee78dbf5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-9f46-7430-af5a-a098ee78dbf5",
        "storage_key": "property/6767906449167306/019d022e-9f46-7430-af5a-a098ee78dbf5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://emeraldcitygyms.com/wallingford",
      "poi_directions_map_url": "https://maps.google.com/?cid=17401796993204784779&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "emerald-city-athletics---wallingford",
      "poi_latitude": "47.6550022",
      "poi_longitude": "-122.3421001",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-557-4909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f28-713c-82ca-ccb5ef2adf99",
        "storage_key": "property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeXjXiv8UkFQRi45uqSqaf_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_89919017-e68d-4905-9910-5d4ef0a04730",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Seattle Children's Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4800 Sand Point Way NE, Seattle, WA 98105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-9f5f-7091-8491-f94c56afee77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-9f5f-7091-8491-f94c56afee77",
        "storage_key": "property/6767906449167306/019d022e-9f5f-7091-8491-f94c56afee77.webp",
        "width": 920,
        "height": 612
      },
      "poi_business_url": "https://www.seattlechildrens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11535247879101277020&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seattle-childrens-hospital",
      "poi_latitude": "47.6628364",
      "poi_longitude": "-122.281996",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 206-987-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-5552-776b-aa15-1d6bee366009.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-5552-776b-aa15-1d6bee366009",
        "storage_key": "property/6767906449167306/019d022e-5552-776b-aa15-1d6bee366009.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJrYx10YIUkFQRXOPoZdRuFaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a7504df2-70d5-4f59-9e6b-831c515f7ac8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Harborview Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "325 9th Ave Main Hospital, Seattle, WA 98104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4506-76bb-b03b-69f95da9f4d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-4506-76bb-b03b-69f95da9f4d9",
        "storage_key": "property/6767906449167306/019d022e-4506-76bb-b03b-69f95da9f4d9.webp",
        "width": 1279,
        "height": 903
      },
      "poi_business_url": "https://www.uwmedicine.org/locations/harborview-medical-center?utm_source=extnet&utm_medium=organic&utm_campaign=website_clicks&y_source=1_MTAwNDcxNDM0Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6803544737971406536&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "harborview-medical-center",
      "poi_latitude": "47.6039167",
      "poi_longitude": "-122.323905",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-744-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-5552-776b-aa15-1d6bee366009.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-5552-776b-aa15-1d6bee366009",
        "storage_key": "property/6767906449167306/019d022e-5552-776b-aa15-1d6bee366009.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7w3EijcVkFQRyIZDeOQLa14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_c6178b3a-c039-4364-8fbf-072d623c69d6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Gas Works Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2101 N Northlake Way, Seattle, WA 98103, USA",
      "poi_short_description": "Former site of an oil plant is now a 20-acre park with picnic facilities & dramatic city views.",
      "poi_long_description": "People say this city park offers beautiful views of the Seattle skyline and Lake Union, and is a great spot for picnics, walks, and family-friendly hangouts. They highlight the unique industrial structures, the spacious green areas, and the fun vibe, especially during summer events and free DJ sets. They also like the convenient parking and the opportunity to watch seaplanes land and take off.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-a378-741b-affe-d281192308e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-a378-741b-affe-d281192308e6",
        "storage_key": "property/6767906449167306/019d022e-a378-741b-affe-d281192308e6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.seattle.gov/parks/allparks/gas-works-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2192784265468010902&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gas-works-park",
      "poi_latitude": "47.6456308",
      "poi_longitude": "-122.3343532",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-523a-7606-ba53-2911ac67e368.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-523a-7606-ba53-2911ac67e368",
        "storage_key": "property/6767906449167306/019d022e-523a-7606-ba53-2911ac67e368.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJf7BbsgIVkFQRlmFJ7KtVbh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_056ead7e-a58e-4853-8286-0e71f228050a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Golden Gardens Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8498 Seaview Pl NW, Seattle, WA 98117, USA",
      "poi_short_description": "City park draws outdoor lovers for Puget Sound & mountain views, trails & a dog off-leash area.",
      "poi_long_description": "People say this city park offers a beautiful beach with amazing sunsets, perfect sand for laying out, and fire pits during the summer. They highlight the stunning views of the water, mountains, and wildlife, as well as the various recreational activities like volleyball, soccer, and frisbee. They also like the cute cafe, playground, and picnic areas with BBQs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-a357-72e0-a061-285d0a7d3cc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-a357-72e0-a061-285d0a7d3cc8",
        "storage_key": "property/6767906449167306/019d022e-a357-72e0-a061-285d0a7d3cc8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/golden-gardens-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6569770599323732682&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-gardens-park",
      "poi_latitude": "47.6917517",
      "poi_longitude": "-122.4030912",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-523a-7606-ba53-2911ac67e368.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-523a-7606-ba53-2911ac67e368",
        "storage_key": "property/6767906449167306/019d022e-523a-7606-ba53-2911ac67e368.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ72JgjmQWkFQRygp_TI2DLFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_332532a3-4908-4f2a-ba01-d866d3fda79d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Discovery Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Seattle, WA 98199, USA",
      "poi_short_description": "Seattle's largest green space features miles of rugged trails & beaches, plus views of the Sound.",
      "poi_long_description": "People say this park offers a variety of hiking trails, including a loop trail with scenic views of the Puget Sound, and a path to a lighthouse and beach. They highlight the peaceful and beautiful atmosphere, and the well-maintained trails suitable for all levels. They also like the ample parking and dog-friendly environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-a32d-7717-a10c-be8a4f69cde0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-a32d-7717-a10c-be8a4f69cde0",
        "storage_key": "property/6767906449167306/019d022e-a32d-7717-a10c-be8a4f69cde0.webp",
        "width": 735,
        "height": 490
      },
      "poi_business_url": "https://www.seattle.gov/parks/allparks/discovery-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5879522751650882336&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "discovery-park",
      "poi_latitude": "47.6613197",
      "poi_longitude": "-122.4171413",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-523a-7606-ba53-2911ac67e368.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-523a-7606-ba53-2911ac67e368",
        "storage_key": "property/6767906449167306/019d022e-523a-7606-ba53-2911ac67e368.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJn0CO4fAVkFQRIGP6pMpCmFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_302c90e7-012d-4d29-9a2d-850e7ac54f74",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Seward Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5900 Lake Washington Blvd S, Seattle, WA 98118, USA",
      "poi_short_description": "Wooded refuge boasting a 300-acre forest with hiking trails, walking paths, beaches & a playground.",
      "poi_long_description": "People say this park offers beautiful views of the lake and Mount Rainier, as well as hiking trails, picnic spots, and a beach. They highlight the peaceful and calming atmosphere, and the well-maintained walkways and trails. They also like the free parking and lake access. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-a49d-7539-9b64-4009bc310945.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-a49d-7539-9b64-4009bc310945",
        "storage_key": "property/6767906449167306/019d022e-a49d-7539-9b64-4009bc310945.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/seward-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4357544938507271096&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seward-park",
      "poi_latitude": "47.5496046",
      "poi_longitude": "-122.2573574",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 206-684-4396",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-523a-7606-ba53-2911ac67e368.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-523a-7606-ba53-2911ac67e368",
        "storage_key": "property/6767906449167306/019d022e-523a-7606-ba53-2911ac67e368.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8fB3DCFqkFQRuPuGyAgceTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ec074552-8697-490c-9129-872dd585b893",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Olympic Sculpture Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2901 Western Ave, Seattle, WA 98121, USA",
      "poi_short_description": "An offshoot of the Seattle Art Museum, this park features numerous sculptures spread over 9 acres.",
      "poi_long_description": "Visitors say this park offers a peaceful waterfront experience with stunning views of the Space Needle, Elliott Bay, and sculptures. They also highlight the dog-friendly atmosphere, walking trails, and benches perfect for picnics or relaxing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-1712-7426-8c4f-15bf585c11a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-1712-7426-8c4f-15bf585c11a0",
        "storage_key": "property/6767906449167306/019d022e-1712-7426-8c4f-15bf585c11a0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.seattleartmuseum.org/visit/olympic-sculpture-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8934295156938678169&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "olympic-sculpture-park",
      "poi_latitude": "47.6166028",
      "poi_longitude": "-122.3553167",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-654-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-523a-7606-ba53-2911ac67e368.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-523a-7606-ba53-2911ac67e368",
        "storage_key": "property/6767906449167306/019d022e-523a-7606-ba53-2911ac67e368.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc88dJ1AVkFQRmZ_S-xv-_Hs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e7096d68-b371-4d52-aeb5-ff0c14507b28",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "U District",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98105, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this light rail station provides convenient access to the U-District and is a clean and safe transportation option. They highlight the station's central location, the helpful screens displaying departure times, and the always-changing art installations. They also like the efficient service and the low cost of travel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-a7d0-746a-b688-984a47890582.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-a7d0-746a-b688-984a47890582",
        "storage_key": "property/6767906449167306/019d022e-a7d0-746a-b688-984a47890582.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.soundtransit.org/ride-with-us/stops-stations/u-district-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=8874690119994055692&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "u-district",
      "poi_latitude": "47.6599885",
      "poi_longitude": "-122.3140745",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f28-713c-82ca-ccb5ef2adf99",
        "storage_key": "property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ93n1LIsUkFQRDBzq3aQ7KXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_d1c00b6e-c583-4f09-8810-92f431991fc3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Westlake",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-a7b6-7614-bd68-bb06a8e7edd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-a7b6-7614-bd68-bb06a8e7edd1",
        "storage_key": "property/6767906449167306/019d022e-a7b6-7614-bd68-bb06a8e7edd1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5693109731314450214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westlake",
      "poi_latitude": "47.61157",
      "poi_longitude": "-122.33672",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f28-713c-82ca-ccb5ef2adf99",
        "storage_key": "property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQQyrwLRqkFQRJj9RIiP9AU8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_ce9a5573-ee23-4a7f-a25c-4550774cdbe7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "University of Washington Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-a952-72d0-be87-8a0a23fb9080.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-a952-72d0-be87-8a0a23fb9080",
        "storage_key": "property/6767906449167306/019d022e-a952-72d0-be87-8a0a23fb9080.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.soundtransit.org/ride-with-us/stops-stations/university-washington-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=18042961121833481987&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-washington-station",
      "poi_latitude": "47.65031",
      "poi_longitude": "-122.30374",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f28-713c-82ca-ccb5ef2adf99",
        "storage_key": "property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIdBrZusUkFQRA3cRa4t5Zfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_036b25d3-b119-4179-8e07-2df17d8cc4ab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Symphony",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022f-bd31-765b-ac39-d02faf5a9e74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022f-bd31-765b-ac39-d02faf5a9e74",
        "storage_key": "property/6767906449167306/019d022f-bd31-765b-ac39-d02faf5a9e74.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10052292521089458792&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "symphony",
      "poi_latitude": "47.60781",
      "poi_longitude": "-122.33602",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f28-713c-82ca-ccb5ef2adf99",
        "storage_key": "property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVRf6wbNqkFQRaGLa4cnqgIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_947ac487-78cc-460c-aaa5-3c47033e1db4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "King County International Airport - Boeing Field",
      "poi_type": "Transportation & Transit",
      "poi_address": "7277 Perimeter Rd S, Seattle, WA 98108, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this airport offers a variety of experiences, including a museum, flight lessons, and opportunities for plane spotting. They highlight the smooth transitions, convenient access to flights, and the friendly staff. They also like the free parking and the efficient, time-saving travel experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-ac15-7535-b6b6-21c1c83e4c23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-ac15-7535-b6b6-21c1c83e4c23",
        "storage_key": "property/6767906449167306/019d022e-ac15-7535-b6b6-21c1c83e4c23.webp",
        "width": 1280,
        "height": 792
      },
      "poi_business_url": "https://www.kingcounty.gov/airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=4635828346216693482&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "king-county-international-airport---boeing-field",
      "poi_latitude": "47.5369043",
      "poi_longitude": "-122.3038555",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 206-296-7380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-553c-76ea-adaf-f307b920df92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-553c-76ea-adaf-f307b920df92",
        "storage_key": "property/6767906449167306/019d022e-553c-76ea-adaf-f307b920df92.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJt_--ofVBkFQR6r7ut1HFVUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_41a208fb-72af-4db1-aa16-58ada470509f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Amazon - Doppler",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2021 7th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-ac12-712a-9220-56b484e92efa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-ac12-712a-9220-56b484e92efa",
        "storage_key": "property/6767906449167306/019d022e-ac12-712a-9220-56b484e92efa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amazon.jobs/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11285464150585336235&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amazon---doppler",
      "poi_latitude": "47.6150245",
      "poi_longitude": "-122.338417",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 888-280-3321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f28-713c-82ca-ccb5ef2adf99",
        "storage_key": "property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJubQpU0oVkFQRq2ELHdoFnpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_03512c9a-a00a-438d-963c-6dd45c456f3b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Amazon re:Invent",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2121 8th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-adf7-7244-afbe-824db5b75ce6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-adf7-7244-afbe-824db5b75ce6",
        "storage_key": "property/6767906449167306/019d022e-adf7-7244-afbe-824db5b75ce6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://amazon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16622250602859019695&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amazon-reinvent",
      "poi_latitude": "47.6167313",
      "poi_longitude": "-122.3386481",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f28-713c-82ca-ccb5ef2adf99",
        "storage_key": "property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHfQ75DIVkFQRrz3v1toYruY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_bc2b82cc-d8ec-4e69-ba79-d6c5a7ba8512",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "The Spheres",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2111 7th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Ultramodern office building with lush botanical gardens, open for public tours by appointment.",
      "poi_long_description": "Ultramodern office building with lush botanical gardens, open for public tours by appointment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-ae50-7569-9f3b-ef7c7e6625a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-ae50-7569-9f3b-ef7c7e6625a5",
        "storage_key": "property/6767906449167306/019d022e-ae50-7569-9f3b-ef7c7e6625a5.webp",
        "width": 1093,
        "height": 1280
      },
      "poi_business_url": "https://www.seattlespheres.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9167585885114143500&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-spheres",
      "poi_latitude": "47.615728",
      "poi_longitude": "-122.3395104",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f28-713c-82ca-ccb5ef2adf99",
        "storage_key": "property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsX8RyksVkFQRDBMdYsrOOX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4f3c3dc0-92ce-47ae-9c2b-e91589db033e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Amazon Nitro North",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2250 7th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-b009-76a3-a347-980362b1479a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-b009-76a3-a347-980362b1479a",
        "storage_key": "property/6767906449167306/019d022e-b009-76a3-a347-980362b1479a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://amazon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=577859250656015239&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amazon-nitro-north",
      "poi_latitude": "47.6174162",
      "poi_longitude": "-122.3408815",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-946-7410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f28-713c-82ca-ccb5ef2adf99",
        "storage_key": "property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBay75mUVkFQRh3OGRe33BAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_fae6464f-1436-4276-8e43-a61ba7cdd4b8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "poi_name": "Expedia Group",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1111 Expedia Group Wy W, Seattle, WA 98119, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-b09f-714a-9aaf-605febf4ae34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022e-b09f-714a-9aaf-605febf4ae34",
        "storage_key": "property/6767906449167306/019d022e-b09f-714a-9aaf-605febf4ae34.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://careers.expediagroup.com/locations/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15469363506382453691&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "expedia-group",
      "poi_latitude": "47.6288379",
      "poi_longitude": "-122.3756115",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 425-679-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022e-4f28-713c-82ca-ccb5ef2adf99",
        "storage_key": "property/6767906449167306/019d022e-4f28-713c-82ca-ccb5ef2adf99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZaBVEIhskFQRuztRGyY4rtY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_8786a4c0a692cb99b537a392",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_0f95223e367e77bbc156f8c3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_7a0c8961d14af14da7d6f4d1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f79063fe69ed8cc9d863e991",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_fc19727e5ecb51866a80478a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_5907d8ce3edd4f65408efe21",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_0b994d4f-2057-4fab-8602-73627b9d828a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "rating": "5.0",
      "name": "Ryan",
      "text": "From finding me the perfect unit to lending me equipment to make my move easier, Tila and Cori made moving into 206 Bell a dream. We decided on Memorial Day weekend for my move in and the few things I requested from them were completed to my satisfaction by Thursday. The building has been tidy, secure and is already starting to feel like home.",
      "date": "2023-06-06",
      "title": ""
    },
    {
      "id": "custom_8e7212f5-6ea3-4fd4-aed2-ef3e66c67d47",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "rating": "5.0",
      "name": "Henry Cabrera",
      "text": "I've been at 206 Bell for about three months now and I have no complaints. The management staff is super responsive, professional, and they always have fun events for the residents. The building is kept clean and the elevators are never out of service. I also love the location, but there are people who are sensitive to having homelessness in their neighborhood, so if this is you, tour the neighborhood beforehand. There are plenty of bars and restaurants within walking distance and the waterfront is about a six minute walk.",
      "date": "2023-12-28",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_632b3264-3a85-4a60-906a-bda2c384f5d9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-5f42-755a-8865-03ec25f69189.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Hallway view towards living area and kitchen with balcony.",
        "public_id": "019d022e-5f42-755a-8865-03ec25f69189",
        "storage_key": "property/6767906449167306/019d022e-5f42-755a-8865-03ec25f69189.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "206 Bell Apartments | Studio 463 SQFT",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=EcNoaJSjBCP"
    },
    {
      "id": "custom_d9a2ec9b-26d8-4817-830f-d5535f9ce9e4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-5f0c-738d-a4e1-2f9e66056cc5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "In-unit washer and dryer stacked next to a closet in an apartment.",
        "public_id": "019d022e-5f0c-738d-a4e1-2f9e66056cc5",
        "storage_key": "property/6767906449167306/019d022e-5f0c-738d-a4e1-2f9e66056cc5.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "206 Bell Apartments | Studio 509 SQFT",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=JPhkyvCbmde"
    },
    {
      "id": "custom_3f875874-fad9-44cd-ac5d-6e118c227a1b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-5f6f-77be-8502-f2491620995a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Hallway view into a bathroom and a living area with a couch.",
        "public_id": "019d022e-5f6f-77be-8502-f2491620995a",
        "storage_key": "property/6767906449167306/019d022e-5f6f-77be-8502-f2491620995a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "206 Bell Apartments | 1 Bedroom | 621 SQFT",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=R3ps9C7Yu1h"
    },
    {
      "id": "custom_38566210-9204-429c-b339-ccc610029d9e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022e-5f42-755a-8865-052104824b9b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Hallway with doors and a closet",
        "public_id": "019d022e-5f42-755a-8865-052104824b9b",
        "storage_key": "property/6767906449167306/019d022e-5f42-755a-8865-052104824b9b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "206 Bell Apartments | 2 Bedroom | 840 SQFT",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=3yrV7nS8Rmx"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019d07b2-5aac-73ff-a47b-a617d6b747d1",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "weidner-206-bell-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167306"
    }
  ],
  "hyperlocal_queries": [],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6021"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11496365686"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=5642627782"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NJRN2TGP"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 7.1"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Aster"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/fb1a0da3-6a9a-4faa-91f0-0549c5177a5e/app.js?property=fb1a0da3-6a9a-4faa-91f0-0549c5177a5e&amp;propertyName=206+Bell+Apartments&amp;channelUuid=d421fcf7-ae11-11ed-8f38-42010aa8d42b&amp;buttonbgcolor=#ed1d24\" defer=\"\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "52910892360"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ii9Kd2NNSDNQYXpiWjViN1VRZlFFTXc9PSIsInZhbHVlIjoiUUphYXVqY2pYcTZRTTVrWHJ1SWlXUT09IiwibWFjIjoiNmUwZjFkNDVkODQ1MTkxMGFiNzExMDRhNWMwMmEyMjM3YzcxZTBjMzVhOTU3MzAxYjE1ZmNmNTYyMzJmZDJlNCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "6021",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11496365686",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=5642627782",
  "custom_google_gtm_id": "GTM-NJRN2TGP",
  "custom_rollout_phase": "Phase 7.1",
  "custom_vibesites_theme": "Aster",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/fb1a0da3-6a9a-4faa-91f0-0549c5177a5e/app.js?property=fb1a0da3-6a9a-4faa-91f0-0549c5177a5e&amp;propertyName=206+Bell+Apartments&amp;channelUuid=d421fcf7-ae11-11ed-8f38-42010aa8d42b&amp;buttonbgcolor=#ed1d24\" defer=\"\"></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "52910892360",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ii9Kd2NNSDNQYXpiWjViN1VRZlFFTXc9PSIsInZhbHVlIjoiUUphYXVqY2pYcTZRTTVrWHJ1SWlXUT09IiwibWFjIjoiNmUwZjFkNDVkODQ1MTkxMGFiNzExMDRhNWMwMmEyMjM3YzcxZTBjMzVhOTU3MzAxYjE1ZmNmNTYyMzJmZDJlNCJ9",
  "custom_audioeye_site_id": "b0b95208-d70c-433f-b647-0e89899720d0",
  "custom_audioeye_site_hash": "fe18f690fe7fa987d52327e44f61350e"
};

export const generatedAt = '2026-10-30T02:11:06.491Z';
